import { EventFormat, Filters, IdentifierFilter } from '@digitalasset/json-api-ts-client';
import { ContractTypeCompanion } from '@daml/types';

export function createEventFormat<T extends object, K, I extends string>(
  contractCompanion: ContractTypeCompanion<T, K, I>,
  parties?: string[],
  verbose = false,
): EventFormat {
  const noParties = !parties || 0 === parties.length;
  const filter: Filters = {
    cumulative: [
      {
        identifierFilter: createIdentifierFilter(contractCompanion),
      },
    ],
  };
  const filtersByParty = Object.fromEntries(
    parties?.map((party): [string, Filters] => [party, filter]) ?? [],
  );
  const filtersForAnyParty = noParties ? filter : undefined;
  return { filtersByParty, filtersForAnyParty, verbose };
}

function isTemplateCompanion<T extends object, K, I extends string>(
  companion: ContractTypeCompanion<T, K, I>,
): boolean {
  return 'encode' in companion;
}

function createIdentifierFilter<T extends object, K, I extends string>(
  companion: ContractTypeCompanion<T, K, I>,
): IdentifierFilter {
  return isTemplateCompanion(companion) ? templateFilter(companion) : interfaceFilter(companion);
}

function templateFilter<T extends object, K, I extends string>(
  companion: ContractTypeCompanion<T, K, I>,
): IdentifierFilter {
  return {
    TemplateFilter: {
      value: {
        templateId: companion.templateId,
        includeCreatedEventBlob: false,
      },
    },
  };
}

function interfaceFilter<T extends object, K, I extends string>(
  companion: ContractTypeCompanion<T, K, I>,
): IdentifierFilter {
  return {
    InterfaceFilter: {
      value: {
        interfaceId: companion.templateId,
        includeInterfaceView: true,
        includeCreatedEventBlob: false,
      },
    },
  };
}
